import { gql } from '@apollo/client';

export const CHECK_EXISTING_CLINIC_PET_PARENT = gql`
  query checkForExistingClinicPetParent($where: ClinicPetParentWhereInput!) {
    findManyClinicPetParent(where: $where) {
      id
      firstName
      lastName
      email
      phoneNumber
      phoneNumbers {
        id
        number
        isPrimary
        isMobile
        isDeleted
      }
      creationSource
      pets {
        id
        name
        species
      }
    }
  }
`;
